<template>
  <div class="container">
    <div class="info">
      <div class="tit">{{ $t('finance').financeProduct }}<svg-icon class-name="ssvgs" icon-class="history" @click="$router.push({ name: 'FinanceList' })" /></div>
      <!-- 产品列表 -->
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getProductList" :immediate-check="false">
        <div class="infoss">
          <div class="item" v-for="(item, index) in pList" :key="`fpro${index}`">
            <div class="nameInfo">
              <img class="imgn" :src="baseUrl + item.img" />
              <div class="right">
                <div class="name">{{item.name}}</div>
                <div class="yield">{{$t('finance').term}}<span>{{item.days}} {{$t('finance').day}}</span></div>
              </div>
            </div>
            <div class="chark">
              <EcharI :id="item.Code" width="100%" height="50px" :Ldata="item.Prices" colors="#02B270" />
            </div>
            <div class="num">{{$t('finance').Mininvestment}}<span>{{ item.lowAmount }} USDT</span></div>
            <div class="num">{{$t('finance').Dailyinterestrate}}<span>{{ item.yieldMin }}% - {{ item.yieldMax }}%</span></div>
            <div class="btn" @click="$router.push({ name: 'FinanceInfo', query: { id: item.financingId } })">{{ $t('finance').Applynow }}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>

</template>

<script>
import productApi from '@/api/product'
import EcharI from '@/components/echarI'

export default {
  components: {
    EcharI,
  },
  data() {
    return {
      baseUrl: window.baseURL,
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      pList: [],
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getProductList()
  },
  methods: {
    // 获取产品列表
    async getProductList() {
      if (this.isRun) return
      this.isRun = true
      const res = await productApi.getFinanceProductList(this.parms)
      this.pList.push(...res.rows.map(item => {
        return {
          ...item,
          Prices: Array.from({ length: 30 }, () => {
            return (Math.random() * 100).toFixed(2)   // 随机价格 0~100
          })
        }
      }));
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .tit {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 50px;

      .ssvgs {
        width: 20px;
        height: 20px;
        color: var(--text_color);
      }
    }

    .infoss {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
      gap: 30px;

      .item {
        background: var(--info_color);
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        border-radius: 12px;
        padding: 30px;
        box-sizing: border-box;
        transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
          box-shadow 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

        &:hover {
          transform: scale(1.02) translateY(-5px);
        }

        .nameInfo {
          display: flex;
          align-items: center;

          .imgn {
            width: 50px;
            height: 50px;
            border-radius: 10px;
            margin-right: 15px;
          }

          .right {
            width: 100%;
            .name {
              font-size: 16px;
              font-weight: bold;
              color: var(--text_color);
            }
            .yield {
              margin-top: 10px;
              font-size: 14px;
              color: var(--ntext_color);

              span {
                margin-left: 5px;
                color: var(--text_color);
              }
            }
          }
        }

        .chark {
          margin-top: 15px;
          width: 100%;
        }

        .num {
          margin-top: 15px;
          display: flex;
          align-content: center;
          justify-content: space-between;
          font-size: 14px;
          color: var(--ntext_color);
          span {
            font-size: 14px;
            color: var(--text_color);
          }
        }

        .btn {
          margin-top: 15px;
          padding: 15px 20px;
          border-radius: 15px;
          font-size: 14px;
          font-weight: normal;
          text-align: center;
          color: var(--background_color);
          background: var(--text_color);

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
